export default function exportAwards(rows) {
  const fields = [
    "id",
    "user_id",
    "campaign_id",
    "source",
    "points",
    "remaining",
    "state",
    "available_at",
    "expires_at",
  ];
  const cell = (value) =>
    `"${String(value ?? "")
      .replace(/^[=+@-]/, "'$&")
      .replace(/"/g, '""')}"`;
  const content = [fields, ...rows.map((row) => fields.map((f) => row[f]))]
    .map((row) => row.map(cell).join(","))
    .join("\r\n");
  const url = URL.createObjectURL(
    new Blob(["\uFEFF", content], {
      type: "text/csv;charset=utf-8",
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = "reward-awards.csv";
  a.click();
  URL.revokeObjectURL(url);
}
